// @ vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LineChart, Line } from 'recharts';

// @components
const CustomizedDot =  require('./customLineChartDots');

class PersoneticsLineChart extends Component {

    render () {
        const { immLineChartData } = this.props;
        const immCategories = immLineChartData.get('categories').map(category => category.get('value').slice(0, -8));

        const immSeries = immLineChartData.get('series');
        const immSeriesdots = immSeries.map(immSerialDot => ({
            value: immSerialDot.get('value'),
            state: immSerialDot.get('category').slice(0, -8)
        }));
        const immLineChartDots = immSeriesdots.map(seriesDot => {
            seriesDot.dot = !!immCategories.includes(seriesDot.state);
            return seriesDot;
        });
        const customDotComponent = <CustomizedDot payload={immLineChartDots.toJS()} cx={20} cy={20}/>;

        return (
            <LineChart width={350} height={100} data={immLineChartDots.toJS()} margin={{top: 20, right: 20, left: 10, bottom: 5}}>
                <Line isAnimationActive={false} type="monotone" dataKey="value" stroke="#fbb800" strokeWidth={3} dot={customDotComponent}/>
            </LineChart>
      );
    }
}

PersoneticsLineChart.propTypes = {
    immLineChartData: PropTypes.array.isRequired
};

export default PersoneticsLineChart;